.branch-picker {
  display: inline-flex;
  align-items: center;
  font-size: var(--mantine-font-size-xs);
  color: var(--mantine-color-dark-2);
  white-space: nowrap;
}
